'use strict'

/**
 * You can use the angular names for the route names, and you won't have
 * to add them here if you do so.
 *
 * will likley refactor this at a later date to use the angular route
 * names as they should be compatible with the vue router.
 */
export default {
  emailsEdit: 'template.manager.editEmail',
  emailsNew: 'template.manager.createEmail',
  userProfile: 'system.profile',

  smsList: 'template.manager.sms',
  smsNew: 'template.manager.createSMS',
  smsEdit: 'template.manager.editSMS',

  allContacts: 'contact.manager.contact.manage',
  contactsEdit: 'contact.manager.contact.view.overview',

  opportunitiesEdit: 'opportunities.manager.edit',

  allLeads: 'leads.manager.singleContainer.all',
  campaignLeads: 'leads.manager.singleContainer.singleCampaign',
  singleAppLeads: 'leads.manager.singleContainer.singleApp',

  formPerformance: 'analytics.manager.forms.singleForm.overview',

  appsList: 'campaigns.manager.manage.type',
  appsListCampaign: 'campaigns.manager.single.type',
  formNew: 'campaigns.embeds.setup',
  appNew: 'campaigns.wizard.setup',

  editApp: 'campaigns.editorAlt.edit',
  editForm: 'campaigns.embedEditor.edit',
  editLegacy: 'campaigns.editor.edit',

  appSettings: 'campaigns.editorAlt.settings',
  formSettings: 'campaigns.embedEditor.settings',
  legacySettings: 'campaigns.editor.settings',

  editUser: 'manage.manager.editUser',
  users: 'manage.manager.users',
  newUser: 'manage.manager.newUser',

  withdrawalRequests: 'withdrawals.manager.manage',
  newSurvey: 'surveys.single_create',
  editSurvey: 'surveys.single_edit',

  allAgencies: 'clients.manager.agencies',
  automationGlobalHistory: 'automation.manager.global',
  automationLogs: 'automation.manager.audit',
  automationNew: 'automation.manager.create',
  automationHistory: 'automation.manager.logs',
  automationEdit: 'automation.manager.edit',

  allBriefs: 'advertising.manager.agency.briefs',
  singleCampaign: 'agencyadquotes.manager.manage.view',
  tacticActivation: 'agencyadquotes.manager.agency.build_and_optimisation',
  assetsDirectory: 'agencyadquotes.manager.agency.assets_directory',
  awaitingAssets: 'agencyadquotes.manager.manage.awaiting_assets_directory',

  eventsList: 'capture.manager.manage.all',
}
